<kendo-formfield class="form-field" [formGroup]="formgroup!">
    <kendo-floatinglabel [text]="t7eLabel">
        <kendo-dropdownlist #contractType class="ddContractType" 
            formControlName="contractType" [data]="contractTypes$ | async" 
            textField="piname"
            valueField="piid" [defaultItem]="defaultItem" name="contractType" 
            [loading]="(loading$ | async)!">
        </kendo-dropdownlist>
    </kendo-floatinglabel>
</kendo-formfield>